import React from "react";
import StepHeader from "../../Evaluation/StepHeader";
import { Label } from "../../ui/label";
import { Textarea } from "../../ui/textarea";

interface TestRunDescriptionProps {
  description?: string;
  onChange: (description: string) => void;
}

const TestRunDescription: React.FC<TestRunDescriptionProps> = ({
  description,
  onChange,
}) => {
  return (
    <div className="space-y-6 w-full">
      <StepHeader
        title="Test Run Details"
        description="Enter a description for your test run"
      />

      <div className="space-y-2 w-full">
        <div className="flex items-center justify-between">
          <Label className="text-sm font-gc-med text-foreground">
            Description <span className="text-red-500">*</span>
          </Label>
        </div>
        <Textarea
          value={description}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Enter test run description"
          className="min-h-[120px] border-input bg-transparent"
        />
        <p className="text-xs text-muted-foreground">
          Provide a concise purpose or context for this test run.
        </p>
      </div>
    </div>
  );
};

export default TestRunDescription;
